import { apiUrl } from "./apiUrl";

/**
 * Map-game APIs (session/org from Bearer token middleware).
 * @param {string|null} adminToken `sessionId&organizationId`
 * @param {string} endpoint e.g. `/mapGameProgress`
 * @param {object} body must include `userId` (and optional `email`, `name`)
 */
export async function postMapGame(adminToken, endpoint, body) {
  if (!adminToken) {
    throw new Error("Missing session token");
  }
  const path = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  const res = await fetch(apiUrl(path), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${adminToken}`,
    },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || data.message || res.statusText || "Request failed");
  }
  return data;
}
